import { makeLoanPersonal } from 'src/main/factories/pages'

export default makeLoanPersonal
